
<template>
  <v-dialog v-model="dialog" max-width="500px">
      <v-card >
          <v-card-title primary class="title py-2">
            <h3>Uredi OIB (update VAT ID)</h3> <br />
            
          </v-card-title>
          <v-card-text>
              <h3>{{ partner.partnerName }}</h3>
            <p>
            email: {{ partner.partneremail }}
            </p>
            <v-row dense>
              <v-flex xs12> 
                <v-text-field
                  label="OIB"
                  v-model="partner.partnerVATID"
                  outlined
                ></v-text-field>
            </v-flex>
            </v-row>  
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-row dense>
              <v-col cols="12" sm="6" md="6" xs="6" lg="6" xl="6">
                <v-btn
                    dark
                    color="green"
                    @click="register" class="mr-2">
                    {{langC.Save}}
                  </v-btn>
              </v-col>
              <v-col cols="12" sm="6" md="6" xs="6" lg="6" xl="6">
                <v-btn
                    color="blue"
                    @click="closeIt">
                    {{langC.Cancel}}
                  </v-btn>
              </v-col>
            </v-row> 
          </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import PartnerService from '@/services/PartnerService'
import PartnerCompanyService from '@/services/PartnerCompanyService'
import { testLastUpdate, newUpdates } from '@/services/TestLastUpdate'
import langEn from './PartnerDescEN'
import langHr from './PartnerDescHR'
import commEn from '@/language/commonEN'
import commHr from '@/language/commonHR'
import dayjs from 'dayjs'

export default {
  name: 'partnerupdatevatid',
  props: ['id'],
  data () {
    return {
      partner: {},
      partnerP: {},
      notFound: false,
      lang:null,
      langC: null,
      dialog: false
    }
  },
  beforeMount() {
    if (this.$store.state.language === 'EN') {
      this.lang = langEn
      this.langC = commEn
    }
    if (this.$store.state.language === 'HR') {
      this.lang = langHr
      this.langC = commHr
    }
  },
  async mounted () {
    const query = {}
    query.CompanyId = this.$store.state.companyid
    this.privateP = "privatePartner" in this.$store.state.user ? this.$store.state.user.privatePartner : true

      try {
        query.partnerId = this.id
        const dbPartner = await PartnerCompanyService.choose(query)
        this.partnerP = dbPartner && dbPartner.data && dbPartner.data.partnercompanys && dbPartner.data.partnercompanys.length > 0 ? dbPartner.data.partnercompanys[0] : {}
        const dbPartner2 = await PartnerService.findbyid(
          parseInt(this.id)
        )
        this.partner = dbPartner2 && dbPartner2.data && dbPartner2.data.partner ? dbPartner2.data.partner : {}
      } catch (error) {
        alert('ERROR!! ', error)
      }
    if (!this.partner || (Object.keys(this.partner).length === 0 && this.partner.constructor === Object)) {
      alert('ERROR!', 'Partner not exist. Partner sa tim ID ne postoji!')
      this.notFound = true
    }
    if (this.partner) {
      this.locCreatedAt = dayjs(this.partner.createdAt).format('DD.MM.YYYY HH:mm')
      this.locUpdatedAt = dayjs(this.partner.updatedAt).format('DD.MM.YYYY HH:mm')
    }
    this.dialog = true
  },
  methods: {
    async register() {
      await this.updatePartner()
    },
    async updatePartner() {
      if (this.notFound === false) {
        try {
          this.partnerP.partnerVATID = this.partner && this.partner.partnerVATID ? this.partner.partnerVATID : null
          if (this.partnerP || (Object.keys(this.partner).length === 0 && this.partner.constructor === Object)) {
            await PartnerCompanyService.put(this.partnerP)
          }
          if (this.partner || (Object.keys(this.partner).length === 0 && this.partner.constructor === Object)) {
            await PartnerService.put(this.partner)
            await newUpdates(2)
            await testLastUpdate()
            this.closeIt()
          }
          if (this.$store.state.partnerStore) {
            this.partners = this.$store.state.partnerStore
          }
        } catch (error) {
          alert('ERROR!', error)
        }
      }
    },
    closeIt () {
      if (this.partner && this.partner.partnerVATID && this.partner.partnerVATID.length > 3) {
        this.$store.dispatch('setPartnerid', this.id)
        this.$store.dispatch('setPartnerVATID', this.partner.partnerVATID)
      }
      this.$store.dispatch('setDialogState', false)
    },  
    async partnerlist () {
      try {
        await this.$router.push({
          name: 'partner'
        })
      } catch (err) {
        this.error = err
      }
    },
  },
  computed: {},
  watch: {},
  components: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
